/**
 * Conservative service-worker registration for the Diesel & Dust Team PWA.
 *
 * - Only registers in production builds (avoids CRA dev-server hot-reload issues).
 * - Watches for updates and fires a custom "dd-sw-update" event so the UI
 *   can offer the user a reload button — never forces a mid-work reload.
 * - Exposes a `promptSkipWaiting()` to activate the new worker on demand.
 */

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Look for updates when the tab regains focus.
      const check = () => reg.update().catch(() => {});
      window.addEventListener("focus", check);
      setInterval(check, 60 * 60 * 1000); // hourly

      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            // A new SW is ready but waiting — surface it to the app shell.
            window.dispatchEvent(new CustomEvent("dd-sw-update", { detail: reg }));
          }
        });
      });
    }).catch((err) => console.warn("[SW] registration failed", err));

    // Reload once the new SW takes over so the user gets fresh assets.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function promptSkipWaiting(registration) {
  const waiting = registration?.waiting || registration;
  if (waiting && waiting.postMessage) waiting.postMessage({ type: "SKIP_WAITING" });
}
